import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { Button, Modal, Table } from 'antd';
import styled from 'styled-components';
import UploadArquivo from '../../molecules/UploadArquivo';
import { requisicaoProps } from '../../atoms/Props';

const CustomTable = styled(Table)`
  .no-padding {
    padding: 5px 16px;
  }
`;

function ModalLimiteReembolso({ visible, onOk, colaboradores, requisicao, onCancel }) {
  const [anexos, setAnexos] = useState([]);

  return (
    <Modal
      width={700}
      title="Limite de reembolso excedido"
      closeable={false}
      open={visible}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => onOk({ anexos })}
        >
          Prosseguir
        </Button>,
        <Button
          key="back"
          onClick={onCancel}
        >
          Cancelar
        </Button>,
      ]}
    >
      <>
        <p>
          Durante o processamento, foi verificado que os cooperados listados constam com o valor de reembolso acima do
          limite.
        </p>
        <CustomTable
          columns={[
            {
              width: '40%',
              title: 'Nome',
              dataIndex: 'nome',
              key: 'nome',
              className: 'no-padding',
            },
            {
              width: '20%',
              title: 'Valor Limite',
              dataIndex: 'limitReembolso',
              key: 'limitReembolso',
              align: 'right',
              className: 'no-padding',
              render: (value) => moneyFormat(value),
            },
            {
              width: '20%',
              title: 'Valor Inserido',
              dataIndex: 'value',
              key: 'value',
              align: 'right',
              className: 'no-padding',
              render: (value) => moneyFormat(value),
            },
            {
              width: '20%',
              title: 'Total Excedido',
              dataIndex: 'overValue',
              key: 'overValue',
              align: 'right',
              className: 'no-padding',
              render: (value) => moneyFormat(value),
            },
          ]}
          dataSource={colaboradores.map((item) => ({
            key: item.cooperator.id,
            nome: item.cooperator.name,
            limitReembolso: item.cooperator.limiteReembolso,
            value: item.reembolso,
            overValue: item.reembolso - item.cooperator.limiteReembolso,
          }))}
          pagination={false}
          scroll={{
            y: 240,
          }}
        />
        <br />
        <p>
          Caso deseje prosseguir, é recomendado adicionar documento de justificativa, para não incidir cobrança extra
          para o cooperado.
        </p>
        <UploadArquivo
          onChangeFiles={(listAnexos) => {
            setAnexos(listAnexos);
          }}
          files={requisicao.anexos}
          requisicao={requisicao}
        />
      </>
    </Modal>
  );
}

ModalLimiteReembolso.propTypes = {
  visible: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  colaboradores: PropTypes.arrayOf(),
  requisicao: requisicaoProps,
};

ModalLimiteReembolso.defaultProps = {
  visible: false,
  colaboradores: [],
  requisicao: {},
};

export default ModalLimiteReembolso;
